/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './AddAndCloseButton.css';

import { CircleAddSlim } from 'components/images/CircleAddSlim';

const AddAndCloseButton = ({ isClose, onClick, className, size }) => (
  <button className={classnames('cmp-addandclosebutton', className, { 'is-closed': isClose })} onClick={onClick}>
    <CircleAddSlim size={30} />
  </button>
);
AddAndCloseButton.propTypes = {
  size: PropTypes.number,
  fontSize: PropTypes.number,
  text: PropTypes.string,
  colorClassName: PropTypes.string,
  isClose: PropTypes.bool,
};
AddAndCloseButton.defaultProps = {
  size: 40,
  fontSize: 14,
  strokeWidth: 1,
};

export default AddAndCloseButton;